import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';

type Props = {
  onSubmit: () => void;
};

class WhatsNextPage extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <>
        <Row>
          <Col>
            <Text type="h3">How to set up a new term</Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <SpacerRow>
              <Text>
                We&apos;ll ask you a few questions about the rent details, move-in costs and your next tenant, then
                we&apos;ll email them an invitation to pay rent and move-in costs online.
              </Text>
            </SpacerRow>
            <SpacerRow>
              <Text>Your new tenant won&apos;t be able to send payments before the start of the next term.</Text>
            </SpacerRow>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button type="primary" full onClick={this.props.onSubmit}>
              OK, got it
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default WhatsNextPage;
